// MessageContext.js
import { createContext } from 'react';

const MessageContext = createContext(); // This is correct
export default MessageContext;
